<template>
  <v-dialog ref="dialog"
            v-model="modal"
            :return-value.sync="date"
            persistent
            lazy
            full-width
            width="290px">

    <template v-slot:activator="{ on }">
      <v-text-field v-model="date"
                    :label="label"
                    :prepend-icon="!($route.name == 'addFunds') ? 'event' : null"
                    readonly
                    v-on="on"></v-text-field>
    </template>

    <v-date-picker v-model="date" scrollable @change="save" :min="minDate" :max="maxDate">
      <v-spacer></v-spacer>
      <v-btn flat color="primary" @click="modal = false">{{ $t('cancel') }}</v-btn>
      <v-btn flat color="primary" @click="$refs.dialog.save(date)">{{ $t('ok') }}</v-btn>
    </v-date-picker>

  </v-dialog>
</template>

<script>
import { getDaysAgo, formatDate } from '@/utils.js'
import Report from '@/client/report'
export default {
  name: 'DateDialogComp',

  props: {
    defaultDate: {
      type: String
    },

    label: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      modal: false,
      date: this.defaultDate || new Date().toISOString().substr(0, 10),
      minDate: '',
      maxDate: ''
    }
  },

  components: {
  },

  computed: {
  },

  methods: {
    save () {
      this.$emit('onSelectDate', this.date)
    },
  },

  watch: {
    defaultDate () {
      this.date = this.defaultDate.substr(0, 10)
    }
  },

  async mounted () {
    if (this.$route.name == 'reports' && !this.$auth.isDev()) {
      const reportLimit = await Report.reportLimit()
      this.minDate = formatDate( getDaysAgo(reportLimit) )
      this.maxDate = formatDate( new Date() )
    }

    if (this.$route.name == 'addFunds') this.maxDate = new Date().toISOString().substr(0, 10)
  }
}
</script>
